import { userService } from "../_services";
import {history, store } from "../_helpers"; 
import { configurationConstants } from "../_constants";

export const ServiceUtil = {
    getServiceUrl,
    handleResponse,
    getRequest,
    postRequest,
    putRequest,
    loadServiceUrls, 
    loadSupportInfo,
    getBanner,
    getHomeBanner,
    getSupportInfo,
    executeServiceCall, 
    executeServiceCallAsync,
    getCurrentUser, 
    setLocalBranchId, 
    getLocalBranchId, 
    setReloadAccountHistory,
    getReloadAccountHistory,
    isSuccessResult, 
    getDeviceId, 
    setDeviceId, 
    clearDeviceId,
    verifyReCaptcha,
    getReCaptchaSiteKey,
    getTrustevKey,
    getTrustevIDVisionResult,
    uploadFile,
    isBusinessHours,
    isLPXState,
    isInstantFundingEnabled,
    isMyDocumentsEnabled,
    isSMSForDocumentsEnabled,
    getDocumentUploadInfo,
    getSharedConfiguration,
    getAccountDashboard,
    isPaymentButtonShown,
    isLPXInMaintenance,
};
let lastRenew = Date.now(); 
function handleResponse(response) {
    return response.text().then(text => {

        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 403) {
                // auto logout if 401 response returned from api
                history.push("/log-out");
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        else{
            if(((Date.now() - lastRenew > 5000)) && userService.shouldRenewToken()){
                userService.renewToken(); 
                lastRenew = Date.now(); 
            }
        }
        return data;
    });
}

function isSuccessResult(result){
    return result.state <= 1; 
}

function getRequest() {
    return baseRequest("GET");
}

function putRequest(body) {
    var requestOptions = baseRequest("PUT");
    requestOptions.body = JSON.stringify(body);
    return requestOptions;
}

function postRequest(body) {

    var requestOptions = baseRequest("POST");
    requestOptions.body = JSON.stringify(body);
    return requestOptions;
}

function setLocalBranchId(branchId){
    sessionStorage.setItem("branchId", String(branchId).padStart(3, '0'));
}

function getLocalBranchId(){
    return sessionStorage.getItem("branchId");
}

function setReloadAccountHistory(reloadAccounthistory) {
    sessionStorage.setItem("reloadAccounthistory", reloadAccounthistory);
}

function getReloadAccountHistory() {
    return sessionStorage.getItem("reloadAccounthistory");
}

function getDeviceId(){
    //check sessionStorage first. 
    if(sessionStorage.getItem("deviceId")) {
        return sessionStorage.getItem("deviceId");
    }
    return localStorage.getItem("deviceId");
}

async function getBanner() {
    return await loadBanner("/Utilities/GetBanner");
}

async function getHomeBanner() {
    return await loadBanner("/Utilities/GetHomeBanner");
}

async function loadBanner(bannerUrl) {
    const request = getRequest();

    var bannerResponse = {
        text: "",
        type: 0,
        showBanner: false,
        showPaymentButton: false
    }

    await window.fetch(bannerUrl, request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            var banner = response.data;
            if (banner) {
                if (banner.showBanner === true) {
                    var userLang = userService.getUserLanguage();
                    if (userLang.toLowerCase() === "es") {
                        bannerResponse.text = banner.spanish;
                    } else {
                        bannerResponse.text = banner.english;
                    }            
                    bannerResponse.type = banner.bannerType;
                }
                bannerResponse.showBanner = banner.showBanner;
                bannerResponse.showPaymentButton = banner.showPaymentButton;
            }
        });

    return bannerResponse;
}

async function isPaymentButtonShown() {
    const request = getRequest();

    var showButton = false;

    await window.fetch("/Utilities/GetBanner", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            var bannerData = response.data;
            if (bannerData) {
                showButton = bannerData.showPaymentButton;
            }
        });

    return showButton;
}

async function getSupportInfo() {
    //check sessionStorage first. 
    if (sessionStorage.getItem("LeadContactNumber") == null) {
        await loadSupportInfo();
        return sessionStorage.getItem("LeadContactNumber");
    }

    var myStorage = sessionStorage.getItem("LeadContactNumber");
    return myStorage;
}

function setDeviceId(deviceId, isRemembered){
    if(isRemembered){
        if(deviceId) {
            localStorage.setItem('deviceId', deviceId);
        }
        else{
            localStorage.removeItem('deviceId');
        }
    }
    else{
        if(deviceId) {
            sessionStorage.setItem('deviceId', deviceId);
        }
        else{
            sessionStorage.removeItem('deviceId');
        }
    }
}

function clearDeviceId(){
    sessionStorage.removeItem('deviceId');
    localStorage.removeItem('deviceId');
}

function getCurrentUser(){
    return userService.getCurrentUser();
}

function baseRequest(method, contentType) {

    // var token = null;
    
    // if (sessionStorage.getItem("user")) {
    //     var userJson = sessionStorage.getItem("user");
    //     var user = JSON.parse(userJson);
    //     token = user.tokenString;
    // }
    var requestHeaders = new window.Headers({
        "Content-Type": contentType ? contentType : "application/json"
    });
    const user = getCurrentUser(); 
    if(user){
        requestHeaders.append("Authorization", "Bearer " + user.tokenString);
        requestHeaders.append("SL.DeviceId", getDeviceId());
    }
    // if (token) {
    //     requestHeaders.append("Authorization", "Bearer " + token);
    // }
    const requestOptions = {
        method: method,
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: requestHeaders,
        redirect: 'follow',
        referrer: 'no-referrer'
    };
    return requestOptions;
}

/*function baseUploadRequest(method) {
    var requestHeaders = new Headers({
        "Content-Type": "multipart/form-data"
    });

    const user = getCurrentUser();

    if (user) {
        requestHeaders.append("Authorization", "Bearer " + user.tokenString);
        requestHeaders.append("SL.DeviceId", getDeviceId());
    }

    const requestOptions = {
        method: method,
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: requestHeaders,
        redirect: 'follow',
        referrer: 'no-referrer',
    };
    return requestOptions;
}*/

let serviceConfig = null;

async function executeServiceCall(serviceName, path, request){
    await loadServiceUrls();
    let serviceUrl = await getServiceUrl(serviceName);
    return window.fetch(serviceUrl + path, request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            return response;
        }).catch(err => {
            return err;
        });
}
async function executeServiceCallAsync(serviceName, path, request){
    try {
        await loadServiceUrls();
        let serviceUrl = await getServiceUrl(serviceName);
        let response = await  window.fetch(serviceUrl + path, request);
        return response;
    } catch (error) {
        console.log("error: ", error);
    }

}
async function loadServiceUrls() {
    if (serviceConfig == null) {

        await getSharedConfiguration();
    }
}

async function verifyReCaptcha(token) {
    var newVerifyRequest = { token: token};
    const request = postRequest(newVerifyRequest);

    var verified = false;

    await window.fetch("/ReCaptcha/Verify", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            verified = response.data.verified;
        });

    return verified;
}

async function getReCaptchaSiteKey() {
    const request =  getRequest();

    var siteKey = "";

    await window.fetch("/Utilities/GetReCaptchaSiteKey", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            siteKey = response.data;
        });

    return siteKey;
}

async function getTrustevKey() {
    const request = getRequest();

    var key = "";

    await window.fetch("/Utilities/GetTrustevKey", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            key = response.data;
        });

    return key;
}

async function getTrustevIDVisionResult(decisionModel) {
    const request = postRequest(decisionModel);
    var result = "";

    await window.fetch("/TransUnion/IDVisionResult", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            result = response.data;
        });

    return result;
}

async function loadSupportInfo() {
    //Get ... 
    const request = getRequest();
    await window.fetch("/Utilities/GetSupportInfo", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            sessionStorage.setItem('LeadContactNumber', response.data.leadContactNumber);
            return response;
        });
}

async function uploadFile(model) {

    var requestOptions = baseRequest("PUT");

    requestOptions.body = JSON.stringify(model);

    await window.fetch("/Document/Upload", requestOptions)
        .then(ServiceUtil.handleResponse);
}

async function getServiceUrl(serviceName) {
    let { serviceUrls } = store.getState().configuration;
    if(serviceUrls === null){
        await loadServiceUrls();
        serviceUrls = store.getState().configuration.serviceUrls;
    }
    return serviceUrls[serviceName];

}

async function isBusinessHours() {
    const request = getRequest();

    var businessHours = false;

    await window.fetch("/Utilities/IsBusinessHours", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            businessHours = response.data;
        });

    return businessHours;
}

async function isLPXState(state) {
    const request = getRequest();

    var isLPX = false;

    await window.fetch("/Utilities/IsLPXState?state=" + state, request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            isLPX = response.data;
        });

    return isLPX;
}

async function isInstantFundingEnabled(state) {
    const request = getRequest();

    var instantFundingEnabled = false;

    await window.fetch("/Utilities/IsInstantFundingEnabled?state=" + state, request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            instantFundingEnabled = response.data;
        });

    return instantFundingEnabled;
}

async function isMyDocumentsEnabled(state) {
    const request = getRequest();

    var myDocumentsEnabled = false;

    await window.fetch("/Utilities/IsMyDocumentsEnabled?state=" + state, request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            myDocumentsEnabled = response.data;
        });        
    return myDocumentsEnabled;
}

async function isSMSForDocumentsEnabled() {
    const request = getRequest();

    var SMSForPictureProofsEnabled = false;

    await window.fetch("/Utilities/isSMSForDocumentsEnabled", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            SMSForPictureProofsEnabled = response.data;
        })
    return SMSForPictureProofsEnabled;
}

async function getDocumentUploadInfo() {
  //check sessionStorage first.   
  let { documentUploadInfo } = store.getState().configuration;
  if (documentUploadInfo == null) {
      getSharedConfiguration();   
    return store.getState().configuration.documentUploadInfo;
  }
  return documentUploadInfo;
}

async function getSharedConfiguration() {
  return await window.fetch("/Configuration/getSharedConfiguration", getRequest())
    .then(ServiceUtil.handleResponse)
    .then((response) => {
        return store.dispatch(success(response.data));
    });

  function success(sharedConfiguration) {
    return {
      type: configurationConstants.SUCCESS,
      sharedConfiguration: sharedConfiguration
    };
  }
}
 

async function getAccountDashboard() {
    return window.fetch("/AccountDashboard/GetAccountDashboard", getRequest())
        .then(ServiceUtil.handleResponse)
        .then((response) => { 
            if (response.data && response.data.length > 0) {
                const loan = response.data[0];
                setLocalBranchId(loan.sunLoanBranchId);
            }
            return response;
        }); 

}
 
async function isLPXInMaintenance() {
    const request = getRequest();
    var isLPXInMaintenance = false;
    await window.fetch("/Utilities/IsLPXInMaintenance", request)
        .then(ServiceUtil.handleResponse)
        .then(response => {
            isLPXInMaintenance = response.data;
        })
    return isLPXInMaintenance;
}


// WEBPACK FOOTER //
// ./src/_services/services.util.js